import { TooltipWrapper } from "@prosolve/common-components-ui"
import styled from "styled-components"

const Card = styled.div`
  padding: 5px 20px 0 20px;

  &:hover {
    background-color: rgb(240, 250, 255);
    cursor: pointer;
  }

  &.flagged {
    border-left: 2px solid red;
  }
`

const Row = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin: 0 5px 10px 0;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const BigNumber = styled.div`
  color: rgb(2, 128, 198);
  font-size: 24px;

  &.IsGenerated {
    color: rgb(248, 135, 0);
    cursor: help;
  }
`

const CardPopup = styled.div`
  padding: 5px 20px 0 20px;
`

export default function OpportunityCardOppItem ({
  opportunity,
  shipModals
}) {
  const {
    Name,
    OpportunityLineItems,
    Order_Flagged__c
  } = opportunity

  const { setManageOppOpportunity } = shipModals

  // Because our generated data only contains Requested, we don't want to include it in the summary of all 4 fields
  const filteredLineItemRecords = OpportunityLineItems?.records?.filter(r => !r.IsGeneratedData)

  const purchased = filteredLineItemRecords?.reduce((acc, rec) => acc + (rec.Quantity || 0), 0) || 0
  const requestedCount = filteredLineItemRecords?.reduce((acc, rec) => acc + (rec.Units_Requested__c || 0), 0) || 0
  const shippedCount = filteredLineItemRecords?.reduce((acc, rec) => acc + (rec.Units_Shipped__c || 0), 0) || 0
  const deliveredCount = filteredLineItemRecords?.reduce((acc, rec) => acc + (rec.Units_Delivered__c || 0), 0) || 0
  const remaining = filteredLineItemRecords?.reduce((acc, rec) => acc + (rec.Units_Remaining_to_Ship__c || 0), 0) || 0
  
  // TODO these should probably be moved to the backend
  const deliveredOnlyCount = deliveredCount
  const shippedOnlyCount = shippedCount - deliveredCount
  const requestedOnlyCount = requestedCount - shippedCount
  const fulfilled = deliveredOnlyCount + requestedOnlyCount + shippedOnlyCount
  const remainingOnlyCount = purchased - fulfilled

  const openManageOpp = () => {
    setManageOppOpportunity(opportunity)
  }

  const fulfilledPopup = (
    <CardPopup>
      <Row>
        <Column>
          <BigNumber>{requestedOnlyCount}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Processing</div>
        </Column>
        <Column>
          <BigNumber>{shippedOnlyCount}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Shipped</div>
        </Column>
        <Column>
          <BigNumber>{deliveredOnlyCount}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Delivered</div>
        </Column>
      </Row>
    </CardPopup>
  )

  const remainingPopup = (
    <CardPopup>
      <Row>
        <Column>
          <BigNumber>{remaining}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Salesforce</div>
        </Column>
        <Column>
          <BigNumber>{remainingOnlyCount}</BigNumber>
          <div style={{ color: 'gray', fontSize: '12px' }}>Live&nbsp;Calculation</div>
        </Column>
      </Row>
    </CardPopup>
  )

  return (
    <>
      <Card onClick={openManageOpp} className={!!Order_Flagged__c && 'flagged'}>
        <Row>
          <Column style={{ flex: '1', alignItems: 'start', minWidth: '150px' }}>
            <div>{Name}</div>
          </Column>
          <Column>
            <BigNumber>{purchased}</BigNumber>
            <div style={{ color: 'gray', fontSize: '12px' }}>Purchased</div>
          </Column>
          <Column>
            <div style={{ borderRight: 'solid 1px silver', minHeight: '30px' }}>&nbsp;</div>
          </Column>
          <Column>
            <TooltipWrapper text={fulfilledPopup}>
              <Column>
                <BigNumber>{fulfilled}</BigNumber>
                <div style={{ color: 'gray', fontSize: '12px' }}>Fulfilled</div>
              </Column>
            </TooltipWrapper>
          </Column>
          <Column>
            <TooltipWrapper text={remainingPopup}>
              <Column>
                <BigNumber>{remaining}</BigNumber>
                <div style={{ color: 'gray', fontSize: '12px' }}>Remaining</div>
              </Column>
            </TooltipWrapper>
          </Column>
        </Row>
      </Card>
    </>
  )
}